import React, { useState } from 'react';
import ReportForm from './ReportForm';
import { type CnReport, type ReportFormData } from './types';

/**
 * Modal component for editing report name and year
 */
type EditReportModalProps = {
  report: CnReport;
  onSave: (data: ReportFormData) => void | Promise<void>;
  onCancel: () => void;
};

export default function EditReportModal({
  report,
  onSave,
  onCancel,
}: EditReportModalProps) {
  const [isSaving, setIsSaving] = useState(false);
  return (
    <div className="cn-edit-modal-overlay">
      <div className="cn-edit-modal-content">
        <h2 className="cn-edit-modal-title">Edit Report</h2>
        <p className="cn-edit-modal-description">
          Update the report name and year. Other details will remain unchanged.
        </p>

        <ReportForm
          initialData={report}
          onSubmit={async (data: ReportFormData) => {
            setIsSaving(true);
            await onSave(data);
            setIsSaving(false);
          }}
          onCancel={onCancel}
          submitLabel="Save Changes"
          isLoading={isSaving}
        />
      </div>
    </div>
  );
}
